// extracted by mini-css-extract-plugin
module.exports = {"main":"DefaultTemplate_main__wplH_","content":"DefaultTemplate_content__OZCMy","placeholders":"DefaultTemplate_placeholders__rtGHB"};